import {useQueryClient} from '@github-ui/react-query'
import {useNavigate} from '@github-ui/react-router'
import {useCallback} from 'react'
import {taskAhpHistoryQueryKey} from '@github-ui/agent-sessions/hooks/use-task-ahp-history'

import {
  chatEventsHistoryQueryKey,
  chatHistoryQueryKeyPrefix,
  chatSessionQueryKey,
  chatSidebarQueryKey,
} from './chat-history'

export interface ConversationDeletion {
  apiUrl: string
  onDeleted: (taskId: string) => void
}

export function useConversationDeletedNavigation(apiURL: string, destination = '/copilot/tasks'): ConversationDeletion {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const onDeleted = useCallback(
    (taskId: string) => {
      queryClient.removeQueries({queryKey: chatSessionQueryKey(apiURL, taskId)})
      queryClient.removeQueries({queryKey: chatEventsHistoryQueryKey(apiURL, taskId), exact: true})
      queryClient.removeQueries({queryKey: taskAhpHistoryQueryKey(taskId, apiURL), exact: true})
      queryClient.invalidateQueries({queryKey: chatSidebarQueryKey(apiURL)})
      queryClient.invalidateQueries({queryKey: chatHistoryQueryKeyPrefix(apiURL)})
      navigate(destination, {replace: true})
    },
    [apiURL, destination, navigate, queryClient],
  )

  return {apiUrl: apiURL, onDeleted}
}
